import { useContext } from "react"

import { VerticalSigningStateContext, VerticalSigningDispatchContext } from "./VerticalSigningContext.context"

export const useVerticalSigningStateContext = () => {
    const context = useContext(VerticalSigningStateContext)
    if (context === undefined) {
        throw new Error("useVerticalSigningStateContext must be used within an VerticalSigningStateContext")
    }
    return context
}

export const useVerticalSigningDispatchContext = () => {
    const context = useContext(VerticalSigningDispatchContext)
    if (context === undefined) {
        throw new Error("useVerticalSigningDispatchContext must be used within an VerticalSigningDispatchContext")
    }
    return context
}

export const useVerticalSigningContext = () => {
    return [useVerticalSigningStateContext(), useVerticalSigningDispatchContext()]
}
